(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["hevisynx-collection-filters"] && !Shopify.designMode) return;
  try {
    document.addEventListener('change', function (event) {
    if (!event.target.matches('[data-hxc-sort]')) return;
    var url = new URL(window.location.href);
    url.searchParams.set('sort_by', event.target.value);
    window.location.assign(url.toString());
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["hevisynx-header-menu"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', function (event) {
    document.querySelectorAll('.hx-site-menu[open]').forEach(function (menu) {
      if (!menu.contains(event.target)) {
        menu.removeAttribute('open');
      }
    });
  });

  document.querySelectorAll('.hx-site-menu').forEach(function (menu) {
    menu.addEventListener('toggle', function () {
      if (!menu.open) return;
      document.querySelectorAll('.hx-site-menu[open]').forEach(function (otherMenu) {
        if (otherMenu !== menu) {
          otherMenu.removeAttribute('open');
        }
      });
    });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["hevisynx-home-merchandising"] && !Shopify.designMode) return;
  try {
    (() => {
  const elementName = 'hevisynx-product-carousel';
  if (customElements.get(elementName)) return;

  class HevisynxProductCarousel extends HTMLElement {
    connectedCallback() {
      if (this._connected) return;
      this._connected = true;
      this._setupFrame = requestAnimationFrame(() => this._connect());
    }

    _connect() {
      if (!this.isConnected) return;
      this._track = this.querySelector('[data-hx-track]');
      if (!this._track) return;
      this._previous = this.querySelector('[data-hx-prev]');
      this._next = this.querySelector('[data-hx-next]');
      this._toggle = this.querySelector('[data-hx-toggle]');
      if (!this._initialized) {
        this._selectProducts(this._track);
        this._initialized = true;
      }
      this._cards = [...this._track.children].filter(card => !card.hasAttribute('data-hx-clone'));
      this._motion = matchMedia('(prefers-reduced-motion: reduce)');
      this._paused ??= this.dataset.designMode === 'true';
      this._visible = false;
      this._hovered = false;
      this._focused = false;
      this._touching = false;
      this._events = new AbortController();
      const signal = this._events.signal;
      const stage = this.querySelector('.hx-home-carousel__stage');
      stage.addEventListener('pointerenter', event => {
        if (event.pointerType === 'mouse') { this._hovered = true; this._syncAnimation(); }
      }, { signal });
      stage.addEventListener('pointerleave', () => { this._hovered = false; this._syncAnimation(); }, { signal });
      this.addEventListener('focusin', event => {
        this._focused = event.target !== this._toggle;
        this._syncAnimation();
      }, { signal });
      this.addEventListener('focusout', () => queueMicrotask(() => {
        if (!this._connected) return;
        this._focused = this.contains(document.activeElement) && document.activeElement !== this._toggle;
        this._syncAnimation();
      }), { signal });
      this._track.addEventListener('mousedown', event => {
        if (event.target.closest('[data-hx-clone]')) event.preventDefault();
      }, { signal });
      this._track.addEventListener('pointerdown', () => {
        this._touching = true;
        this._syncAnimation();
      }, { passive: true, signal });
      const release = () => {
        if (!this._touching) return;
        this._touching = false;
        this._deferResume();
      };
      window.addEventListener('pointerup', release, { passive: true, signal });
      window.addEventListener('pointercancel', release, { passive: true, signal });
      this._track.addEventListener('wheel', () => this._deferResume(), { passive: true, signal });
      this._track.addEventListener('scroll', () => {
        if (!this._animation) this._deferResume();
      }, { passive: true, signal });
      this._track.addEventListener('keydown', event => this._onKeyDown(event), { signal });
      this._previous?.addEventListener('click', () => this._scrollBy(-1), { signal });
      this._next?.addEventListener('click', () => this._scrollBy(1), { signal });
      this._toggle?.addEventListener('click', () => {
        this._paused = !this._paused;
        this._resumeAt = 0;
        this._syncAnimation();
      }, { signal });
      document.addEventListener('visibilitychange', () => this._syncAnimation(), { signal });
      this._motion.addEventListener('change', () => this._syncAnimation(), { signal });
      this._observer = new ResizeObserver(() => this._measure());
      this._observer.observe(this._track);
      this._intersection = new IntersectionObserver(entries => {
        this._visible = entries[0].isIntersecting;
        this._syncAnimation();
      }, { threshold: 0.15 });
      this._intersection.observe(this._track);
      this._measure();
    }

    _selectProducts(track) {
      const pool = this.querySelector('template[data-hx-pool]');
      if (!pool?.content) return;
      const seen = new Set();
      const products = [];
      for (const card of pool.content.querySelectorAll('a[data-product-id]')) {
        const id = card.getAttribute('data-product-id')?.trim();
        if (!id || seen.has(id)) continue;
        seen.add(id);
        products.push(card);
      }
      if (!products.length) return;
      if (this.dataset.designMode !== 'true') {
        for (let index = products.length - 1; index > 0; index--) {
          const swap = Math.floor(Math.random() * (index + 1));
          [products[index], products[swap]] = [products[swap], products[index]];
        }
      }
      const requestedCount = parseInt(this.dataset.count || '12', 10);
      const count = Number.isFinite(requestedCount) && requestedCount > 0 ? requestedCount : 12;
      track.replaceChildren(...products.slice(0, count).map(product => product.cloneNode(true)));
    }

    _cloneCards() {
      const fragment = document.createDocumentFragment();
      for (const card of this._cards) {
        const clone = card.cloneNode(true);
        clone.setAttribute('data-hx-clone', '');
        clone.setAttribute('aria-hidden', 'true');
        clone.setAttribute('tabindex', '-1');
        clone.removeAttribute('aria-labelledby');
        clone.removeAttribute('id');
        clone.querySelectorAll('[id]').forEach(node => node.removeAttribute('id'));
        fragment.appendChild(clone);
      }
      return fragment;
    }

    _measure() {
      const oldWidth = this._loopWidth || 0;
      const offset = oldWidth ? (this._track.scrollLeft % oldWidth) / oldWidth : 0;
      const width = (this._cards[0]?.getBoundingClientRect().width || 0) * this._cards.length;
      const overflowing = width > this._track.clientWidth + 1;
      if (overflowing && !this._loopWidth) {
        this._track.prepend(this._cloneCards());
        this._track.append(this._cloneCards());
      } else if (!overflowing && this._loopWidth) {
        this._track.querySelectorAll('[data-hx-clone]').forEach(card => card.remove());
      }
      this._loopWidth = overflowing ? width : 0;
      this._track.classList.toggle('is-looping', overflowing);
      if (Math.abs(oldWidth - this._loopWidth) > 0.5) {
        this._track.scrollLeft = this._loopWidth ? this._loopWidth * (1 + offset) : 0;
        this._position = this._track.scrollLeft;
      }
      const controls = this.querySelector('[data-hx-controls]');
      if (controls) controls.hidden = !overflowing;
      this._syncAnimation();
    }

    _deferResume() {
      this._resumeAt = performance.now() + 4000;
      clearTimeout(this._resumeTimer);
      this._resumeTimer = setTimeout(() => this._syncAnimation(), 4050);
      this._syncAnimation();
    }

    _syncAnimation() {
      if (!this._connected || !this._track) return;
      if (this._toggle) {
        this._toggle.hidden = !this._loopWidth || this._motion.matches;
        this._toggle.setAttribute('aria-label', this._paused ? this._toggle.dataset.play : this._toggle.dataset.pause);
        this._toggle.querySelector('[data-hx-toggle-label]').textContent = this._paused ? this._toggle.dataset.play : this._toggle.dataset.pause;
        this._toggle.classList.toggle('is-paused', this._paused);
      }
      const running = this._loopWidth && this._visible && !document.hidden && !this._motion.matches &&
        !this._paused && !this._hovered && !this._focused && !this._touching && !(performance.now() < this._resumeAt);
      if (running && !this._animation) {
        this._position = this._track.scrollLeft;
        this._lastTime = 0;
        this._animation = requestAnimationFrame(time => this._tick(time));
      } else if (!running && this._animation) {
        cancelAnimationFrame(this._animation);
        this._animation = 0;
      }
    }

    _tick(time) {
      const elapsed = this._lastTime ? Math.min(time - this._lastTime, 48) : 0;
      this._lastTime = time;
      this._position += elapsed * 0.034;
      if (this._position >= this._loopWidth * 2) this._position -= this._loopWidth;
      if (this._position < this._loopWidth) this._position += this._loopWidth;
      this._track.scrollLeft = this._position;
      this._animation = requestAnimationFrame(nextTime => this._tick(nextTime));
    }

    _scrollBy(direction) {
      if (!this._loopWidth) return;
      this._deferResume();
      const position = this._loopWidth + (this._track.scrollLeft % this._loopWidth);
      this._track.scrollLeft = position;
      this._track.scrollTo({ left: position + direction * this._track.clientWidth, behavior: this._motion.matches ? 'instant' : 'smooth' });
    }

    _onKeyDown(event) {
      if (event.target !== this._track || !this._loopWidth) return;
      if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
        event.preventDefault();
        this._scrollBy(event.key === 'ArrowLeft' ? -1 : 1);
      } else if (event.key === 'Home' || event.key === 'End') {
        event.preventDefault();
        this._deferResume();
        this._track.scrollTo({
          left: this._loopWidth + (event.key === 'End' ? this._loopWidth - this._track.clientWidth : 0),
          behavior: this._motion.matches ? 'instant' : 'smooth'
        });
      }
    }

    disconnectedCallback() {
      this._connected = false;
      this._events?.abort();
      this._observer?.disconnect();
      this._intersection?.disconnect();
      cancelAnimationFrame(this._setupFrame);
      cancelAnimationFrame(this._animation);
      clearTimeout(this._resumeTimer);
      this._animation = 0;
      this._resumeAt = 0;
      this._track?.querySelectorAll('[data-hx-clone]').forEach(card => card.remove());
      this._loopWidth = 0;
    }
  }
  customElements.define(elementName, HevisynxProductCarousel);
})();
  } catch(e) { console.error(e); }
})();

})();
